<template>
    <div :id="this.$route.name">
        <Card back >
            <template v-slot:header>
            <h4 class="d-inline">{{title}}</h4>
            <hr>    
            </template>
            <template v-slot:content>
                <form autocomplete="off">
                    <div class="row">
                        <div class="col-md-3 col-12">
                            <small id="LblAlarmText">متن یادآوری</small>
                            <textarea rows="3" type="text" id="TaskDes" class="form-control required" v-model="DataAxios.AlarmText" ></textarea>     

                        </div>
                        <div class="col-md-3 col-12">
                            <small id="LblDateAlarm"> تاریخ یادآوری</small>
                            <date-picker input-class="required form-control" color="dimgray" :min="$store.state.JalaliDate" type="datetime"  v-model="DataAxios.DateAlarm" clearable :editable="true" placeholder="تاریخ یادآوری" ></date-picker>
                        </div>
                        <div class="col-md-3 col-12">
                            <small id="LblDateAlarm"> نوع یادآوری</small>
                            <SearchableCombo
                                :edit="false"
                                :code="null"
                                :ActiveDelete="true"
                                @ResultCombo="GetAlarmType"
                                :defaultvalue="grp59Defaultvalue"
                                :rownumintable="3"
                                :grp="59"
                                :action="'TblCrmCombo/GetComboById'"
                                :method="'POST'"
                                :idinput="'Id'"
                                :keyItem="'Nmae'"
                                :disabled="false"
                                >
                            </SearchableCombo>
                        </div>
                        <div v-if="$route.params.Status=='Edit'" class="col-md-3 col-12">
                        <small id="LblIsView">مشاهده شد</small>
                        <div class="form-control custom-switch">
                        <input type="checkbox" class="form-control-input InputText m-1" id="IsView"  v-model="DataAxios.IsView"  />
					        <label  class="label txt-bnp  mr-2" for="IsView">
					           مشاهده شد
					        </label>
					    </div>
                    </div>
                    </div>
                    <BtnEditData v-if="$route.params.Status=='Edit'" :DataParanet="DataAxios"></BtnEditData>
                    <BtnSaveData v-if="$route.params.Status=='Add'" :DataParanet="DataAxios"></BtnSaveData>
                </form>
                
            </template>
        </Card>
    </div>
</template>
<script>
import Card from '@/components/Card/Card.vue';
import BtnSaveData from '@/components/BnpButtons/BtnSaveData.vue';
import BtnEditData from '@/components/BnpButtons/BtnEditData.vue';
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import SearchableCombo from '@/components/Combo/SearchableCombo.vue'
export default {
    data() {
        return {
            title:'',
            DataAxios:{},
            grp59Defaultvalue: null
        };
    },
    components: { Card, BtnSaveData, BtnEditData,datePicker: VuePersianDatetimePicker, SearchableCombo},
    created(){
        if (this.$route.params.Status) {
            if (this.$route.params.Status == "Add") {
                 this.title='اضافه کردن یادآور'
            }else{
                this.title='ویـرایـش یادآور'
            }
        }else{
            this.$router.push({ name: this.$route.name.substring(6)});
        }
    },
    mounted(){ 
        if(this.$route.params.Status == "Edit") {
            this.DataAxios=this.$route.params.DataRow
            this.DataAxios.TblUserGrpIdLastEdit=this.$session.get("UserInfo").tblUserGrpId
            this.$store.state.OldDataForLog=JSON.stringify(this.DataAxios)
            this.DataAxios.tblUserId=this.$session.get('UserInfo').tblUserId
            this.grp59Defaultvalue  = this.DataAxios.AlarmType
        }
         if (this.$route.params.Status == "Add") {
            this.DataAxios.TblUserGrpIdInsert=this.$session.get("UserInfo").tblUserGrpId
            this.DataAxios.tblUserId=this.$session.get('UserInfo').tblUserId
         }
    },
    methods:{
        GetAlarmType(data) {
            if(data != undefined & data != null){
                this.DataAxios.AlarmType = data.id
            }
        },
    }
}
</script>
<style scoped>

</style>